export const ROLE = {
  ADMIN: "admin",
  GLOBAL_ADMIN: "global-admin",
  GLOBAL_ADMIN_SUPPORT: "global-admin-support",
  ASHA: "asha",
  ANM: "anm",
};
